export default {"src":"/_next/static/media/logo-kbbank.80ccfde6.svg","height":120,"width":231,"blurWidth":0,"blurHeight":0};